import React, {useEffect} from "react";
import {Link} from "react-router-dom";

function NotFound() {

    useEffect(() => {
        document.title = '페이지를 찾을 수 없습니다'
    })

    return (
        <div className="body">
            <div className="container">
                {/*Outer Row*/}
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card o-hidden border-0 shadow-lg my-5">
                            <div className="card-body p-0">
                                {/*Nested Row within Card Body*/}
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="p-5">
                                            <div className="text-center">
                                                <h1 className="h4 text-gray-900 mb-4">페이지를 찾을 수 없습니다.</h1>
                                            </div>
                                            <hr/>
                                            <div className="text-center">
                                                <h2 className="h5 text-gray-900 mb-4">처음으로 돌아가시려면 <Link
                                                    to={"/login"}>여기</Link>를 눌러주세요</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotFound;